import React from 'react';
import { motion } from 'framer-motion';
import setup from '../assets/data/setup.json';
import MotionSection from './ui/MotionSection';
import SectionHeader from './ui/SectionHeader';
import { integrationIconMap } from './ui/integrationIcons';

function Integrations() {
  return (
    <MotionSection id="integrations">
      <SectionHeader
        eyebrow="Platforms"
        title="Technologies & Integrations"
        subtitle="Enterprise systems and APIs connected in production."
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {setup.integrations.map((integration, index) => (
          <motion.div
            key={integration.name}
            initial={{ opacity: 0, scale: 0.95, filter: 'blur(4px)' }}
            whileInView={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: index * 0.03 }}
            whileHover={{ y: -3 }}
            className="ui-card ui-card-lift flex flex-col items-center justify-center p-4 sm:p-5 text-center min-h-[96px] gap-2"
          >
            <div className="text-ink-secondary opacity-80">
              {integrationIconMap[integration.icon] ?? integrationIconMap.api}
            </div>
            <span className="text-sm font-medium text-ink-secondary leading-snug">
              {integration.name}
            </span>
          </motion.div>
        ))}
      </div>
    </MotionSection>
  );
}

export default Integrations;
